module.exports = __webpack_public_path__ + "img/hardware4.8469af60.png";